import { render, staticRenderFns } from "./ArticleSum.component.vue?vue&type=template&id=8d48d5e8&scoped=true"
import script from "./ArticleSum.component.vue?vue&type=script&lang=ts"
export * from "./ArticleSum.component.vue?vue&type=script&lang=ts"
import style0 from "./ArticleSum.component.vue?vue&type=style&index=0&id=8d48d5e8&prod&scoped=true&lang=css"
import style1 from "./ArticleSum.component.vue?vue&type=style&index=1&id=8d48d5e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d48d5e8",
  null
  
)

export default component.exports